import * as THREE from 'three';

const manager = new THREE.LoadingManager();//定义加载跟踪容器

let load={
  jinxing:0,
  over:true
}

manager.onStart = function (url, itemsLoaded, itemsTotal) {
  // console.log('载入的模型: ' + url + '.\n目前已加载项的个数。 ' + itemsLoaded + ' 总共所需要加载项的个数 '
  //   + itemsTotal + ' 文件');
};

manager.onProgress = function (url, itemsLoaded, itemsTotal) {
//   UidApp.loadWidthev = itemsLoaded / itemsTotal * 1//环境加载速度---

  // console.log('载入的模型: ' + url + '.\n目前已加载项的个数 ' + itemsLoaded + ' 总共所需要加载项的个数 '
  //   + itemsTotal + ' 文件进度');

    if(itemsLoaded==itemsTotal){
      // console.log('加载检测陈宫');
      load.over=false
    }


};
manager.onError = function (url) {

};

manager.onLoad = function () {
  load.over=true
    // console.log('加载成功');
 
}
//追踪器效果
export{manager,load}